// Checkable items belonging to one step. Creation and reorder are nested under their task;
// per-row operations address the item directly at /api/task-items — the same nested-plus-flat
// split tasks themselves use (see tasks.js).
export function createTaskItemsApi(http) {
  return {
    create: (taskId, body) => http.post(`/api/tasks/${taskId}/items`, body),
    patch: (id, body) => http.patch(`/api/task-items/${id}`, body),
    remove: (id) => http.del(`/api/task-items/${id}`),
    markDone: (id) => http.post(`/api/task-items/${id}/done`),
    markUndone: (id) => http.del(`/api/task-items/${id}/done`),
    reorder: (taskId, order) => http.patch(`/api/tasks/${taskId}/items/reorder`, { order }),
  }
}
